import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'; // Importa useLocation
import HomePage from './pages/HomePage';
import MyCertificatesPage from './pages/Student/MyCertificatesPage';
import VerificationPage from './pages/Public/VerificationPage';
import AdminHomePage from './pages/Admin/AdminHomePage';
import UploadCertificatesPage from './pages/Admin/UploadCertificatesPage';
import ManageTemplatesPage from './pages/Admin/ManageTemplatesPage';
import CreateTemplatePage from './pages/Admin/CreateTemplatePage';
import ManageEventsPage from './pages/Admin/ManageEventsPage';
import CreateEventPage from './pages/Admin/CreateEventPage';  
import NavigationBar from './components/Navigation/NavigationBar';
import AdminLayout from './components/Admin/AdminLayout';
import LoginPage from './pages/LoginPage/LoginPage';
import PrivateRoute from './components/Auth/PrivateRoute';
import { AuthProvider } from './context/AuthContext';

// Importaciones de Organizadores
import ManageOrganizersPage from './pages/Admin/ManageOrganizersPage';
import CreateEditOrganizerPage from './pages/Admin/CreateEditOrganizerPage';

// Importaciones de Firmas
import ManageSignaturesPage from './pages/Admin/ManageSignaturesPage';
import CreateEditSignaturePage from './pages/Admin/CreateEditSignaturePage'; 

// Importaciones de Participantes
import ManageParticipantsPage from './pages/Admin/ManageParticipantsPage';
import CreateEditParticipantsPage from './pages/Admin/CreateEditParticipantsPage';

function AppContent() {
    const location = useLocation();
    // Determina si la ruta actual es una ruta de administración
    const isAdminRoute = location.pathname.startsWith('/admin');

    return (
        <>
            {/* Renderiza NavigationBar solo si NO es una ruta de administración */}
            {!isAdminRoute && <NavigationBar />}
            

                <Routes>
                    {/* Rutas públicas */}
                    <Route path="/" element={<HomePage />} />
                    <Route path="/student/certificates" element={<MyCertificatesPage />} />
                    <Route path="/verify" element={<VerificationPage />} />
                    <Route path="/login" element={<LoginPage />} />

                    {/* Rutas de administración protegidas */}
                    <Route path="/admin" element={<PrivateRoute><AdminLayout /></PrivateRoute>}>
                        <Route index element={<AdminHomePage />} />
                        <Route path="upload" element={<UploadCertificatesPage />} />
                        <Route path="templates" element={<ManageTemplatesPage />} />
                        <Route path="templates/create" element={<CreateTemplatePage />} />
                        <Route path="templates/edit/:id" element={<CreateTemplatePage />} />
                        <Route path="events" element={<ManageEventsPage />} /> 
                        <Route path="events/create" element={<CreateEventPage />} />
                        <Route path="events/edit/:id" element={<CreateEventPage />} />

                        {/* Gestión de organizadores */}
                        <Route path="organizers" element={<ManageOrganizersPage />} /> {/* Listado de organizadores */}
                        <Route path="organizers/create" element={<CreateEditOrganizerPage />} /> {/* Creación de organizador */}
                        <Route path="organizers/edit/:id" element={<CreateEditOrganizerPage />} /> {/* Edición de organizador */}

                        {/* Gestión de firmas */}
                        <Route path="signatures" element={<ManageSignaturesPage />} /> {/* Listado de firmas */}
                        <Route path="signatures/create" element={<CreateEditSignaturePage />} /> {/* Creación de firma */}
                        <Route path="signatures/edit/:id" element={<CreateEditSignaturePage />} /> {/* Edición de firma */}

                        {/* Gestión de participantes */}
                        <Route path="participants" element={<ManageParticipantsPage />} /> {/* Listado de firmas */}
                        <Route path="participants/create" element={<CreateEditParticipantsPage />} /> {/* Creación de firma */}
                        <Route path="participants/edit/:id" element={<CreateEditParticipantsPage />} /> {/* Edición de firma */}


                    </Route>
                </Routes>

        </>
    );
}

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <AppContent /> {/* Envuelve el contenido principal en un componente interno para usar useLocation */}
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
